import './style.css'

import React from 'react'

import { useFormErrors } from '@/hooks/useFormErrors'
import { getSlugTranslation } from '@/locale/utils'

interface CheckboxProps {
  id: string
  textKey: string
  required?: boolean
  error?: boolean
  onBlur?: React.ChangeEventHandler<HTMLInputElement>
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  checked?: boolean
  tabIndex?: number
}

export const Checkbox = ({ id, textKey, required, error, onBlur, onChange, checked, tabIndex }: CheckboxProps) => {
  const { getFieldError } = useFormErrors()

  const hasError = Boolean(getFieldError(id) || error)

  return (
    <div className="checkbox-container">
      <svg className="checkbox-symbol">
        <symbol id="check" viewBox="0 0 12 10">
          <polyline points="1.5 6 4.5 9 10.5 1" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </symbol>
      </svg>

      <input
        id={id}
        tabIndex={tabIndex}
        data-testid={`${id}-input`}
        type="checkbox"
        required={required}
        onBlur={onBlur}
        onChange={onChange}
        checked={checked}
        className="checkbox-input"
      />

      <label htmlFor={id} className={`checkbox ${hasError ? 'error' : ''}`}>
        <span>
          <svg width="20px" height="20px">
            <use xlinkHref="#check" />
          </svg>
        </span>

        <span
          data-testid={`${id}-checkbox-label`}
          id={`${id}-checkbox-label`}
          className="checkbox-label"
          dangerouslySetInnerHTML={{
            __html: getSlugTranslation(textKey)
          }}
        />
      </label>
    </div>
  )
}
